export default {
  title: "惡意地址風險監控",
  subtitle: "最近24小時涉案地址轉賬信息",
  viewMore: "查看更多",
  statistics: {
    associatedAddresses: "關聯地址數",
    totalTransactions: "轉入總交易",
    totalAmount: "轉入總數量",
  },
};
